import { getStoredAuthState } from "auth/modules/util";

export function getUserKey(): string {
    // eject if there is no localStorage
    if (!localStorage) {
        return;
    }

    const userObj = getStoredAuthState();

    if (userObj && userObj.hasOwnProperty("profile") && userObj.profile && userObj.profile.hasOwnProperty("userId")) {
        return userObj.profile.userId;
    }

    // just in case there is a userObj without .profile or profile.sub
    return "";
}